import React, { useState, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  TableCell,
  IconButton,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

const ListCell = ({
  value,
  options,
  onSave,
  onChange,
  valueName,
  menuStyle = {},
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  // console.log("value", value);
  // console.log("options", options);

  useEffect(() => {
    if (typeof value === "string") {
      // Find the ID(s) corresponding to the material name(s)
      const selectedIds = options
        .filter((option) => value.includes(option.name)) // Check if the name exists in the value
        .map((option) => option.id); // Map to their IDs

      setSelectedValue(selectedIds);
      //   console.log("selectedIds", selectedIds);
    } else if (Array.isArray(value)) {
      // Find the ID(s) corresponding to the material name(s)
      const selectedIds = options
        .filter((option) => value.includes(option.name)) // Check if the name exists in the value
        .map((option) => option.id); // Map to their IDs

      setSelectedValue(selectedIds); // Set selectedValue to the corresponding IDs
      //   console.log("selectedIds", selectedIds);
    } else if (typeof value === "object" && value !== null) {
      // Find the ID(s) corresponding to the material name(s)
      const selectedIds = options
        .filter((option) => value.includes(option.name)) // Check if the name exists in the value
        .map((option) => option.id); // Map to their IDs

      setSelectedValue(selectedIds); // Set selectedValue to the corresponding IDs
      //   console.log("selectedIds", selectedIds);
    } else {
      console.log("Unhandled value type", value);
    }
  }, [value, options]);

  const handleDoubleClickCell = () => {
    setIsEditing(true);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue); // Update selected value
    // console.log("Selected value changed:", newValue); // Log selected value change
    onChange(newValue); // Propagate the change upwards
  };

  const handleSave = () => {
    // console.log("Saving changes...");
    console.log("Selected value:", selectedValue); // Log selected value before saving
    setIsEditing(false);
    if (selectedValue) {
      onSave(selectedValue);
    }
    // Save the selected values to the parent component
  };

  const handleBlurCell = () => {
    setIsEditing(false); // Exit edit mode on blur
    // console.log("Blurred. Saving selected value:", selectedValue); // Log selected value on blur
    if (selectedValue) {
      onSave(selectedValue);
    }
    // Save the selected values when focus is lost
  };

  return (
    <TableCell
      onDoubleClick={handleDoubleClickCell} // Activate editing on double-click
      style={{
        padding: "8px",
        borderBottom: "1px solid #ddd",
        cursor: "pointer",
      }}
    >
      {isEditing ? (
        <FormControl fullWidth>
          <Select
            multiple
            value={selectedValue}
            onChange={handleChange}
            onBlur={handleBlurCell}
            renderValue={(selected) => {
              return selected
                ?.map((id) => {
                  const option = options.find((option) => option.id === id);
                  return option ? option.name : "";
                })
                .join(", ");
            }}
            MenuProps={{
              PaperProps: {
                style: {
                  fontWeight: "bold",
                  color: "#FFFFFF",

                  cursor: "pointer",
                  backgroundColor: "#2E4053",
                  ...menuStyle,
                },
              },
            }}
          >
            {options.map((option) => (
              <MenuItem
                key={option.id}
                value={option.id}
                selected={selectedValue.includes(option.id)}
                style={{
                  backgroundColor: selectedValue.includes(option.id)
                    ? "#2E4053"
                    : "white",
                  color: selectedValue.includes(option.id) ? "#FFFFFF" : "#555",
                }}
              >
                {option.name}
              </MenuItem>
            ))}
          </Select>
          <IconButton onClick={handleSave} style={{ color: "#2E4053" }}>
            <SaveIcon />
          </IconButton>
        </FormControl>
      ) : (
        <>
          <span
            style={{
              display: "block",
              width: "50px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {Array.isArray(value) ? value.join(", ") : value}
          </span>{" "}
          {/* Display current material(s) */}
        </>
      )}
    </TableCell>
  );
};

export default ListCell;
